module.exports = __webpack_public_path__ + "static/media/header-background.8ddd6870.svg";